module.exports = __webpack_public_path__ + "assets/fonts/OverpassMono-w600.c750571c9eb9756c4688b2201eda9d25.ttf";